<!--标签管理页面-->
<template>
  <div class="label-manage">
    <gs-modal
      v-model="visible"
      :before-close="beforeClose"
      title="标签管理"
      class="label-manage-modal"
      width="600px"
      top="10%"
      @close="close"
      append-to-body
    >
      <!-- 标签列表区域 -->
      <div class="label-list-container">
        <div class="label-list-content">
          <div class="label-items-container">
            <div
              v-for="(tag, index) in tagList"
              :key="tag.id || index"
              class="label-item"
            >
              <div class="label-checkbox">
                <gs-checkbox
                  v-model="selectedTags"
                  :label="tag.id"
                  @change="handleTagSelect"
                />
              </div>
              <div
                class="label-name"
                :class="{ active: selectedTags.includes(tag.id) }"
              >
                {{ tag.name }}
              </div>
            </div>
          </div>

          <div class="no-label" v-if="tagList.length === 0">暂无标签</div>
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <div slot="footer" class="dialog-footer">
        <gs-button type="primary" @click="handleConfirm">确定</gs-button>
      </div>
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import service from "../../service/leftService.js";

export default {
  name: "LabelManage",
  data() {
    return {
      // 标签列表数据
      tagList: [],
      // 选中的标签ID数组
      selectedTags: [],
      // 新增/编辑弹窗显示状态
      addEditVisible: false,
      // 查看资源弹窗显示状态
      viewResourceVisible: false,
      // 查看资源弹窗标题
      viewResourceTitle: "",
      // 资源列表
      resourceList: [],
      // 当前查看的标签
      currentViewTag: null,
      // 是否为编辑模式
      isEdit: false,
      // 当前编辑的标签
      currentTag: null,
      // 要删除的标签
      // 表单数据
      tagForm: {
        name: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapState({
      visible: "ehiLabelManageShow", // EHI专用的标签管理状态
    }),
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.loadTagList();
        this.selectedTags = [];
      }
    },
    addEditVisible(newVal) {
      if (newVal && this.$refs.nameInput) {
        setTimeout(() => {
          this.$refs.nameInput.focus();
        }, 100);
      }
    },
  },
  methods: {
    ...mapMutations({
      close: "EHI_LABEL_MANAGE_HIDE",
    }),

    // 加载标签列表
    async loadTagList() {
      try {
        const response = await service.findAllPointLabel();
        this.tagList = response || [];
      } catch (error) {
        console.error("加载标签列表失败:", error);
        this.$message.error("加载标签列表失败");
      }
    },

    beforeClose() {
      this.close();
    },

    handleConfirm() {
      if (this.selectedTags.length === 0) {
        this.$message.warning("请选择标签");
        return;
      }

      this.$emit(
        "confirm",
        this.tagList.filter((tag) => this.selectedTags.includes(tag.id))
      );
      this.close();
    },

    // 显示新增弹窗
    showAddDialog() {
      this.isEdit = false;
      this.tagForm = {
        name: "",
      };
      this.addEditVisible = true;
    },

    // 处理标签选择（使用checkbox实现单选）
    handleTagSelect(selectedValues) {
      // 如果选择了多个，只保留最后一个
      if (selectedValues.length > 1) {
        this.selectedTags = [selectedValues[selectedValues.length - 1]];
      }
      // 可以在这里添加选择标签后的逻辑
    },
  },
};
</script>

<style scoped lang="scss">
>>> .gs-checkbox-label {
  display: none;
}
.label-manage {
  position: relative;
}

.label-manage-modal {
  z-index: 2000;
}

.label-list-container {
  padding: 20px;
}

.label-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.add-btn {
  background-color: #ff9500;
  border-color: #ff9500;
}

.add-btn:hover {
  background-color: #e6850e;
  border-color: #e6850e;
}

.label-list-content {
  max-height: 400px;
  overflow-y: auto;
}

.label-items-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.label-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  color: #fff;
  width: calc(100% / 3 - 10px);
}

.label-checkbox {
  margin-bottom: 8px;
  margin-right: 12px;
}

.label-name {
  flex: 1;
  font-size: 14px;
  color: #fff;
  transition: color 0.3s;
}

.label-name.active {
  color: #ff9500;
  font-weight: bold;
}

.label-actions {
  display: flex;
  gap: 8px;
}
.label-actions i {
  cursor: pointer;
}

.label-actions .gs-button {
  padding: 4px 8px;
  font-size: 12px;
}

.delete-btn {
  color: #ff4d4f;
}

.delete-btn:hover {
  color: #ff7875;
}

.dialog-footer {
  text-align: right;
  padding: 10px 0;
}

.dialog-footer .gs-button {
  margin-left: 10px;
}

.view-resource-modal {
  z-index: 2001;
}

.add-edit-modal {
  z-index: 2002;
}

.delete-content {
  text-align: center;
  padding: 20px 0;
}

.delete-content p {
  margin: 10px 0;
  color: #666;
}

.delete-tip {
  font-size: 12px;
  color: #999;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .label-manage-modal {
    width: 90% !important;
  }

  .add-edit-modal {
    width: 80% !important;
  }

  .delete-modal {
    width: 70% !important;
  }
}

/* 滚动条样式 */
.label-list-content::-webkit-scrollbar {
  width: 6px;
}

.label-list-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.label-list-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.label-list-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.no-label {
  text-align: center;
  padding: 20px 0;
  color: #999;
}

.resource-list-container {
  padding: 10px 0;
}

.resource-list {
  max-height: 300px;
  overflow-y: auto;
}

.resource-item {
  padding: 12px 16px;
  margin-bottom: 8px;
  background-color: #666;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-all;
}

.no-resource {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}
/* 隐藏checkbox的标签文字 */
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EHI/labelManage.vue